<div class="main-container">

  @if(!isMobile) {
    <h1 class="page-title-center">Account</h1>
  }

  <div class="main-row">
    <div class="label-value">
      <div class="label">Name</div>
      <div class="value">{{ user?.first_name }} {{ user?.last_name }}</div>
    </div>
    @if (allowNameChange) {
      <button mat-flat-button [routerLink]="['/account/name']" matTooltip="Change Name">Edit</button>
    }
  </div>

  <div class="main-row">
    <div class="label-value">
      <div class="label">Cell phone</div>
      <div class="value">{{ formatPhoneNumber(user?.cell_phone) }}</div>
    </div>
    @if (allowCellPhoneChange) {
      <button mat-flat-button [routerLink]="['/account/cell-phone']" matTooltip="Change Cell Phone">Edit</button>
    }
  </div>

  <div class="main-row">
    <div class="label-value">
      <div class="label">Direct Phone</div>
      <div class="value">{{ formatPhoneNumber(user?.direct_phone) || 'None' }}</div>
    </div>
    <button mat-flat-button [routerLink]="['/account/direct-phone']" matTooltip="Change Direct Phone">Edit</button>
  </div>

  <div class="main-row">
    <div class="label-value">
      <div class="label">Email</div>
      <div class="value">{{ user?.email }}</div>
    </div>
    @if (allowEmailChange) {
      <button mat-flat-button [routerLink]="['/account/email']" matTooltip="Change Email">Edit</button>
    }
  </div>

  <div class="main-row">
    <div class="label-value">
      <div class="label">Additional emails</div>

      <div class="value">
        @if (additionalEmails.length > 0) {
          @for (email of additionalEmails; track email.id) {
            <div class="additional-email-row">
              <span>{{ email.email }}</span>

              <button
                mat-icon-button
                type="button"
                matTooltip="Remove Email"
                (click)="deleteAdditionalEmail(email)"
              >
                <mat-icon>close</mat-icon>
              </button>
            </div>
          }
        } @else {
          <span>None</span>
        }
      </div>
    </div>

    <button
      mat-flat-button
      [routerLink]="['/account/additional-email']"
      matTooltip="Add Additional Email"
      class="add-button"
    >
      Add
    </button>
  </div>

  <div class="main-row">
    <div class="label-value">
      <div class="label">Password</div>
      <div class="value">*********</div>
    </div>
    <button mat-flat-button [routerLink]="['/account/password']" matTooltip="Change Password">Edit</button>
  </div>

  @if (allowDeleteAccount) {
    <div class="main-row last-row">
      <button class="danger-button" mat-button [routerLink]="['/account/delete']" type="button" matTooltip="Delete Account">
        Delete Account
      </button>
    </div>
  }

</div>
